import { t } from 'i18next';
import { z } from 'zod';
import { UnionOfKeys } from '@anytag/shared-types';
import { getCsvPagesAndRowsValidationSchema, CSV_EXPORT_TYPE } from './validation-schema';

export { CSV_EXPORT_TYPE };

const SCHEMA = getCsvPagesAndRowsValidationSchema(t, 1);
export type DownloadCsvPagesAndRowsModalValues = z.infer<typeof SCHEMA>;

export type DownloadCsvPagesAndRowsModalKeys = UnionOfKeys<DownloadCsvPagesAndRowsModalValues>;
